import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
import '../assets/css/FenetreDescription.css'
import { Grid } from '@mui/material';

function FenetreDescription({ afficher, setAfficherFenetre, descriptionpoints }) {

    //serveur bdd1 sensible à la casse, passe des noms en minuscule
    let nomImage
    if(descriptionpoints.photo){
        nomImage = descriptionpoints.photo.toLowerCase()
    }
    
    if (!afficher) return null;

    const fermer = () => {
        setAfficherFenetre(false);
    }
    const handlePopupClick = (e) => {
        e.stopPropagation();
    }
    
    let nomPicto
    switch (descriptionpoints.thematique) {
        case 'Esport':
            nomPicto = "Picto e-sport_Centre esport.svg";
            break;
        case 'Formation pluridisciplinaire':
            nomPicto = "Picto e-sport_Formation pluridisciplinaire.svg";
            break;
        case 'Studio':
            nomPicto = "Picto e-sport_Studio.svg";
            break;
        case 'Formation esport':
               nomPicto = "Picto e-sport_Formation esport.svg";
            break;
        case 'Distributeur':
               nomPicto = "Picto e-sport_Distributeur.svg";
            break;
        case 'Formation informatique':
               nomPicto = "Picto e-sport_Formation informatique.svg";
            break;
        case 'Editeur':
               nomPicto = "Picto e-sport_Editeur.svg";
            break;
        default:
            console.log('pas de pictos');
      }
      
    let images = require.context('../assets/pictos', true);
    // let theme = descriptionpoints.thematique
    let itemImg = images(`./${nomPicto}`);
    // console.log({theme})
    return (
        <div id="popup_container" onClick={fermer}>
         
            <div className={"popup"} onClick={handlePopupClick}>
            <div className="FenetreDescription_boutton">
              <CloseIcon onClick={fermer} />
            </div>
                <div className="popup_vis_titre1">
                    {descriptionpoints.photo && descriptionpoints.photo !== "" ? (
                        <img
                            className={"popup_image"}
                            alt={descriptionpoints.titre}
                            src={
                                process.env.PUBLIC_URL +"/images/" +nomImage
                            }
                        />
                    ) : null}
                    <div>
                        <img src={itemImg} className="popup_picto" alt={descriptionpoints.nom} title={descriptionpoints.nom} />
                        <div className="popup_titre">{descriptionpoints.nom}</div>
                    </div>
                </div>
                <div className="popup_separation"></div>
                <div className="popup_description">{descriptionpoints.texte}</div>
                {descriptionpoints.nb_salle &&
                    descriptionpoints.nb_salle !== "" &&
                    descriptionpoints.nb_fauteuil &&
                    descriptionpoints.nb_fauteuil !== "" ? (
                    <>
                        <div className="popup_separation"></div>
                        <div className="popup-adresse">
                            {descriptionpoints.nb_salle &&
                                descriptionpoints.nb_salle !== "" ? (
                                <div>
                                    Nombre de salles: <b>{descriptionpoints.nb_salle}</b>
                                </div>
                            ) : null}
                            {descriptionpoints.nb_fauteuil &&
                                descriptionpoints.nb_fauteuil !== "" ? (
                                <div>
                                    Nombre de fauteuils: <b>{descriptionpoints.nb_fauteuil}</b>
                                </div>
                            ) : null}
                        </div>
                    </>
                ) : null}
                <div className="popup_separation"></div>
                <div className="popup-adresse">
                    <div>
                        <b>Adresse:</b> {descriptionpoints.adresse},{" "}
                        {descriptionpoints.cp}, {descriptionpoints.ville}
                    </div>
                    {descriptionpoints.tel && descriptionpoints.tel !== "" ? (
                        <div>
                            <b>Téléphone : </b>
                            {descriptionpoints.tel}
                        </div>
                    ) : null}
                    {descriptionpoints.mail && descriptionpoints.mail !== "" ? (
                        <div>
                            <b>Email : </b>{" "}
                            <a href={`mailto:${descriptionpoints.mail}`}>
                                {descriptionpoints.mail}
                            </a>
                        </div>
                    ) : null}

                    {descriptionpoints.url && descriptionpoints.url !== "" ? (
                        <div>
                            <b>Site web:</b>{" "}
                            <a
                                target="_blank"
                                rel="noreferrer"
                                href={descriptionpoints.url}>
                                {descriptionpoints.url}
                            </a>
                        </div>
                    ) : null}
                </div>
            </div>
      </div>
    );
    


    // return (
    //     <>
    //         <div className="FenetreDescription_fond"></div>
    //         <div className="FenetreDescription_fenetre">
    //             <div className="FenetreDescription_boutton">
    //                 <CloseIcon onClick={fermer} />
    //             </div>

    //             <div className="FenetreDescription_contenu">
    //                 <Grid container className='FenetreDescription_container'>
    //                     <Grid item xs={12} sm={2} md={2} lg={1} xl={1} >
    //                         <h1 style={{color:descriptionpoints.couleur}}>{descriptionpoints.numero}</h1>
    //                     </Grid>
    //                     <Grid item xs={12} sm={10} md={10} lg={11} xl={11} >
    //                         {descriptionpoints.titre ?
    //                             <Grid container alignItems={"baseline"}>
    //                                 <Grid item>
    //                                     <h2 style={{color:descriptionpoints.couleur}}>{descriptionpoints.titre}</h2>
    //                                 </Grid>
    //                             </Grid>
    //                             :
    //                             null
    //                         }
    //                         {descriptionpoints.natureduprojet ?
    //                             <Grid container alignItems={"baseline"} className="FenetreDescription_natureprojet">
    //                                 <Grid item xs={12} sm={6} md={5} lg={3} xl={3}>Nature du projet</Grid>
    //                                 <Grid item xs={12} sm={6} md={7} lg={9} xl={9}>: {descriptionpoints.natureduprojet}</Grid>
    //                             </Grid>
    //                             :
    //                             null
    //                         }
    //                         {descriptionpoints.maitriseouvrage ?
    //                             <Grid container alignItems={"baseline"} className="FenetreDescription_maitriseouvrage">
    //                                 <Grid item xs={12} sm={6} md={5} lg={3} xl={3}>Maitrise d’ouvrage</Grid>
    //                                 <Grid item xs={12} sm={6} md={7} lg={9} xl={9}>: {descriptionpoints.maitriseouvrage}</Grid>
    //                             </Grid>
    //                             :
    //                             null
    //                         }
    //                         {descriptionpoints.objectifspoursuivis ?
    //                             <Grid container alignItems={"baseline"} className="FenetreDescription_bordure">
    //                                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>OBJECTIFS POURSUIVIS</Grid>
    //                                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
    //                                     <div className="FenetreDescription_texte" dangerouslySetInnerHTML={{ __html: descriptionpoints.objectifspoursuivis }}/>
    //                                 </Grid>
    //                             </Grid>
    //                             :
    //                             null
    //                         }
    //                         {descriptionpoints.programmeetudesettravaux ?
    //                             <Grid container alignItems={"baseline"} className="FenetreDescription_bordure">
    //                                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>PROGRAMME DES TRAVAUX</Grid>
    //                                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
    //                                     <div className="FenetreDescription_texte" dangerouslySetInnerHTML={{ __html: descriptionpoints.programmeetudesettravaux }}/>
    //                                 </Grid>
    //                             </Grid>
    //                             :
    //                             null
    //                         }
    //                         {descriptionpoints.planningetcalendrier ?
    //                             <Grid container alignItems={"baseline"} className="FenetreDescription_sansbordure">
    //                                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>PLANNING PREVISIONNEL</Grid>
    //                                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
    //                                     <div className="FenetreDescription_texte" dangerouslySetInnerHTML={{ __html: descriptionpoints.planningetcalendrier }}/>
    //                                 </Grid>
    //                             </Grid>
    //                             :
    //                             null
    //                         }
    //                         {descriptionpoints.financement ?
    //                             <Grid container alignItems={"baseline"} className="FenetreDescription_sansbordure">
    //                                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>FINANCEMENT</Grid>
    //                                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
    //                                     <div className="FenetreDescription_texte" dangerouslySetInnerHTML={{ __html: descriptionpoints.financement }}/>
    //                                 </Grid>
    //                             </Grid>
    //                             :
    //                             null
    //                         }
    //                         {descriptionpoints.datesaisie ?
    //                             <Grid container alignItems={"baseline"} className="FenetreDescription_natureprojet">
    //                                 <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>DATE DE SAISIE DES INFORMATIONS</Grid>
    //                                 <Grid item xs={12} sm={6} md={6} lg={8} xl={9}>: {descriptionpoints.datesaisie}</Grid>
    //                             </Grid>
    //                             :
    //                             null
    //                         }

    //                     </Grid>
    //                 </Grid>
    //             </div>

    //         </div>

    //     </>
    // )
}

FenetreDescription.defaultProps = {
    afficher: false,
    setafficherFenetre: () => { },
    descriptionpoints: {}
}

export default FenetreDescription
